// extracted by mini-css-extract-plugin
export var icon = "_aa-3";
export var subtitle = "_aa-2";
export var title = "_aa-1";
export var value = "_aa-0";